import Vue from 'vue'
import { wtLabelGroups } from '@/walkthroughs/wtData'
import { lotteryLabels } from '@/lotteryUserData'
import pagingMap from '@/helpers/pagination'

function getPromoGroup(state, payload) {
    return state.labelGroups?.find(group => group.id === payload.groupId)
}
function getSelectedPromoGroup(state, payload) {
    return state.selectedLabelGroups?.find(group => group.id === payload.groupId)
}

function getSelectedPromoGroupPromo(state, payload) {
    const searchedGroup = state.selectedLabelGroups.find(
        group => group.id === payload.groupId
    )
    return (
        searchedGroup &&
        searchedGroup.promos.find(el => el.id === payload.promoId)
    )
}

export const labelGroups = {
    state: {
        downloadLabelGroupsQueues: [],
        priceTagConfig: {
            merchant_header: true,
            guides: true,
            variant: 'normal'
        },
        status: 'idle',
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 5,
            totalRecords: null
        },
        promosLoad: {
            initial: 2,
            big: 100
        },
        labelGroups: null,
        labels: null,
        selectAll: false,
        selectedLabelGroups: [],
        price_tags: {
            merchant_header: true,
            guides: true,
            variant: 'normal',
            labels_attributes: []
        },
        sortOptions: [
            {
                query: 'id',
                label: 'ID'
            },
            {
                query: 'name',
                label: 'Nazwa grupy'
            }
        ],
        sort: {
            by: 'id',
            direction: 'desc'
        },
        filters: {
            activePromos: {
                type: 'ui-checkbox-input',
                value: false,
                text: 'już trwające',
                groupName: 'promoCheckboxes',
                groupTitle: 'Czas trwania',
                notToSend: true
            },
            endingPromos: {
                type: 'ui-checkbox-input',
                value: false,
                text: 'kończące się w ciągu 7 dni',
                groupName: 'promoCheckboxes',
                notToSend: true
            },
            startingPromos: {
                type: 'ui-checkbox-input',
                value: false,
                text: 'rozpoczynające się w ciągu 7 dni',
                groupName: 'promoCheckboxes',
                notToSend: true
            },
            'promo|query': {
                type: 'search-input',
                value: '',
                promoFilter: 'query',
                searchParamsTooltip: ['nazwie grupy', 'nazwie promocji', 'ID promocji', 'nazwie produktu', 'kodzie EAN']
            },
            'promo|company_id': {
                type: 'checkboxes',
                value: [],
                getter: 'getCompaniesForPromoFilters',
                text: 'Organizator',
                firstOption: 'Wszyscy',
                expectedType: 'string'
            },
            'promo|type': {
                type: 'checkboxes',
                value: [],
                getter: 'geLabelPromoTypesForPromoFilters',
                text: 'Typy promocji',
                firstOption: 'Wszystkie',
                expectedType: 'string'
            },
            'promo|subscription|merchant|nip': {
                type: 'checkboxes',
                value: [],
                getter: 'getUserCompaniesForSelect',
                text: 'Moje firmy',
                firstOption: 'Wszystkie',
                expectedType: 'string',
                disabledLinkGenerator: true,
                additionalText: 'Firma'
            },
            'promo|subscription|merchant_id': {
                type: 'checkboxes',
                value: [],
                getter: 'getLabelGroupsMerchantsForSelect',
                text: 'Sklepy',
                firstOption: 'Wszystkie',
                disabledLinkGenerator: true,
                expectedType: 'string'
            }
        },
        labelGroupsShopsContacts: [],
        companiesForLabelFilters: [],
        promoTypesForPromoFilters: [],
        downloadStatus: 'idle',
        labelMaxPrice: 999.99,
        walkthroughModalLabelsStep: 1,
        weightProductsErrors: null,
        unloadedPromosMandatoryPrice: [],
        mandatoryPricePromoGroupsStatus: 'idle',
        mandatoryPricePromoGroups: [],
        mandatoryPriceValidation: false,
        isCancelMandatoryPricePromoGroupsLoad: false,
        mandatoryPriceError: false
    },
    mutations: {
        SET_LABELGROUPS_STATUS(state, payload) {
            state.status = payload
        },
        SET_WALKTHROUGH_MODAL_LABELS_STEP(state, payload) {
            state.walkthroughModalLabelsStep = payload
        },
        SET_LABELGROUPS_SHOP_CONTACTS(state, payload) {
            state.labelGroupsShopsContacts = payload
        },
        SET_LABELGROUPS_MERCHANT_HEADER(state, payload) {
            state.priceTagConfig.merchant_header = payload
        },
        SET_LABELGROUPS_GUIDES(state, payload) {
            state.priceTagConfig.guides = payload
        },
        SET_LABELGROUPS_VARIANT(state, payload) {
            state.priceTagConfig.variant = payload
        },
        ADD_TO_DOWNLOAD_QUEUE(state, payload) {
            state.downloadLabelGroupsQueues.push(payload)
        },
        SET_DOWNLOAD_LABELGROUPS_STATUS(state, payload) {
            state.downloadStatus = payload
        },
        SET_SELECTED_LABELGROUPS(state, payload) {
            state.selectedLabelGroups = payload
        },

        SET_LABELGROUPS_PER_PAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_LABELGROUPS_PAGINATION_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SET_LABELGROUPS_PAGINATION(state, payload) {
            state.pagination = payload
        },
        SET_SELECTED_LABELGROUP_STATUS(state, payload) {
            const searchedGroup = getSelectedPromoGroup(state, payload)
            if (searchedGroup) {
                searchedGroup.status = payload.status
            }
        },
        SET_LABELGROUPS_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },
        RESET_LABELGROUPS_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_LABELGROUP_STATUS(state, payload) {
            const loadingSelectedPromoIds = payload.loadingSelectedPromoIds
                ? payload.loadingSelectedPromoIds
                : false
            const searchedGroup = getPromoGroup(state, payload)
            if (searchedGroup) {
                searchedGroup.status = payload.status
                Vue.set(
                    searchedGroup,
                    'loadingSelectedPromoIds',
                    loadingSelectedPromoIds
                )
            }
        },
        SET_LABELPROMO_SELECTED_SHOPS(state, payload) {
            const promoGroups = JSON.parse(
                JSON.stringify(state.selectedLabelGroups)
            )
            const promoGroup = promoGroups.find(
                group => group.id === payload.groupId
            )
            const selectedPromo = promoGroup.promos.find(
                promo => promo.id === payload.promoId
            )

            if (payload.equalPrices) {
                selectedPromo.subscriptionsEqualPrices.priceGroups[
                    payload.groupIdx
                ] = payload.subscriptions
            } else {
                selectedPromo.subscriptions = payload.subscriptions
            }

            state.selectedLabelGroups = promoGroups
        },
        CLEAR_LABELGROUP_PROMOS(state, payload) {
            const searchedGroup = getPromoGroup(state, payload)
            searchedGroup.promos = []
        },
        SET_SELECTED_LABELGROUP_PROMOS(state, payload) {
            const searchedGroup = getSelectedPromoGroup(state, payload)

            payload.promos.forEach(promo => {
                const alreadyAddedPromo = searchedGroup.promos.find(
                    e => e.id === promo.id
                )
                if (alreadyAddedPromo) {
                    Object.assign(alreadyAddedPromo, promo, {
                        promoDetailsNotFetched: false
                    })
                } else {
                    searchedGroup.promos.push(promo)
                }
            })

            searchedGroup.promos.forEach(promo => {
                for (const sub of promo.subscriptions) {
                    let selectedMerchants = state.filters['promo|subscription|merchant_id'].value

                    if (state.mandatoryPricePromoGroups || [].length) {
                        const mandatoryPricePromoGroup = state.mandatoryPricePromoGroups.find(
                            el => el.promo_group_id === searchedGroup.id
                        )
                        if (mandatoryPricePromoGroup) {
                            const mandatoryPricePromo = mandatoryPricePromoGroup.promos.find(
                                el => el.promo_id === promo.id
                            )
                            if (mandatoryPricePromo) {
                                selectedMerchants = mandatoryPricePromo.merchant_id
                            }
                        }
                    }
                    if (selectedMerchants.length) {
                        sub.checked = selectedMerchants.includes(sub.merchant_id)
                    } else if (sub.checked === undefined) {
                        sub.checked = true
                    }
                }
            })
        },
        SET_LABELGROUP_PROMO(state, payload) {
            const searchedGroup = getPromoGroup(state, payload)
            if (!searchedGroup) return

            const promo = searchedGroup.promos.find(
                p => p.id === payload.promoId
            )
            if (!promo) return

            Object.assign(promo, payload.promo)
        },
        SET_LABELGROUP_PROMOS(state, payload) {
            const searchedGroup = getPromoGroup(state, payload)
            if (!searchedGroup) return

            if (payload.fromFilters) {
                searchedGroup.promos = payload.promos
            } else {
                searchedGroup.promos.push(...payload.promos)
            }

            searchedGroup.promos.forEach(promo => {
                if (!promo.subscriptions) return
                promo.subscriptions.forEach(sub => {
                    if (sub.checked === undefined) {
                        sub.checked = true
                    }
                })
            })
        },
        SET_LABELGROUPS(state, payload) {
            state.labelGroups = payload
        },
        SET_LABELGROUP(state, payload) {
            const searchedGroup = getPromoGroup(state, payload)
            if (!searchedGroup) return

            Object.assign(searchedGroup, payload.group)
        },
        SET_SELECTED_LABELGROUP_PAGINATION(state, payload) {
            const searchedGroup = getSelectedPromoGroup(state, payload)
            searchedGroup.pagination = payload.pagination
        },
        SET_LABELGROUP_PAGINATION(state, payload) {
            const searchedGroup = getPromoGroup(state, payload)
            if (searchedGroup) {
                searchedGroup.pagination = payload.pagination
            }
        },
        SET_LABELGROUPS_SORT(state, payload) {
            state.sort = payload
        },
        SET_LABEL_PROMO_TYPES_FOR_PROMO_FILTERS(state, payload) {
            state.promoTypesForPromoFilters = payload
        },
        SET_WEIGHT_PRODUCTS_ERRORS(state, payload) {
            state.weightProductsErrors = payload
        },
        SET_UNLOADED_PROMOS_MANDATORY_PRICE(state, payload) {
            state.unloadedPromosMandatoryPrice = payload
        },
        SET_SELECTED_LABELGROUPS_SELECTWHOLEGROUP(state, payload) {
            state.selectedLabelGroups.forEach(el => {
                el.selectWholeGroup = payload
            })
        },
        SET_MANDATORY_PRICE_PROMO_GROUPS_STATUS(state, payload) {
            state.mandatoryPricePromoGroupsStatus = payload
        },
        SET_MANDATORY_PRICE_PROMO_GROUPS(state, payload) {
            state.mandatoryPricePromoGroups = payload
        },
        SET_MANDATORY_PRICE_VALIDATION(state, payload) {
            state.mandatoryPriceValidation = payload
        },
        SET_CANCEL_MANDATORY_PRICE_PROMO_GROUPS_LOAD(state, payload) {
            state.isCancelMandatoryPricePromoGroupsLoad = payload
        },
        SET_MANDATORY_PRICE_ERROR(state, payload) {
            state.mandatoryPriceError = payload
        }
    },
    actions: {
        async sendLabelGroups({ state, getters }) {
            await this.$api.post(
                'saveShopsContacts',
                state.labelGroupsShopsContacts
                    .filter(e => e.selected)
                    .map(e => {
                        return {
                            shop_id: e.shop_id,
                            contact_person_name: e.contact_person_name,
                            contact_person_email: e.contact_person_email
                        }
                    })
            )

            const sendMailPriceTagsResponse = await this.$api.post(
                'pricing/send_email',
                Object.assign(state.priceTagConfig, {
                    labels_attributes: getters.getPriceTagsAttributes,
                    selectedManagers: state.labelGroupsShopsContacts
                        .filter(e => e.selected)
                        .map(el => el.shop_id)
                })
            )

            if (sendMailPriceTagsResponse.status === 200) {
                return sendMailPriceTagsResponse
            } else {
                throw sendMailPriceTagsResponse
            }
        },
        labelsShopContactUpdate({ state, commit }, payload) {
            const contacts = state.labelGroupsShopsContacts
            const findContact = contacts.find(
                el => el.shop_id === payload.shop_id
            )

            if (findContact) {
                Object.assign(findContact, payload)
            } else {
                contacts.push({ ...payload, selected: false })
            }

            commit('SET_LABELGROUPS_SHOP_CONTACTS', contacts)
        },

        selectAllShopContacts({ state, commit }, payload) {
            const stateContacts = state.labelGroupsShopsContacts

            stateContacts.forEach(el => {
                if (payload) {
                    if (el.contact_person_name && el.contact_person_email) {
                        const isEmail = (email = null) => {
                            // eslint-disable-next-line
                            const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                            return regex.test(email)
                        }
                        if (isEmail(el.contact_person_email)) {
                            el.selected = payload
                        }
                    }
                } else {
                    el.selected = payload
                }
            })
            commit('SET_LABELGROUPS_SHOP_CONTACTS', stateContacts)
        },
        selectLabelGroupsShopContact({ commit, state }, payload) {
            const contacts = state.labelGroupsShopsContacts
            const findContact = contacts.find(
                el => el.shop_id === payload.shop_id
            )

            findContact.selected = payload.selected
            commit('SET_LABELGROUPS_SHOP_CONTACTS', contacts)
        },
        async labelsShopsContactsFetch({ commit }) {
            const res = await this.$api.get('shopsContacts')
            let shops = []
            if (res.data.data) {
                shops = res.data.data.map(shop => {
                    shop.selected = false
                    return shop
                })
            }

            commit('SET_LABELGROUPS_SHOP_CONTACTS', shops)
        },
        clearLabelGroups({ commit }, payload) {
            commit('SET_LABELGROUPS', [payload])
        },
        setLabelGroupsMerchantHeader({ commit }, payload) {
            commit('SET_LABELGROUPS_MERCHANT_HEADER', payload)
        },
        setLabelGroupsGuides({ commit }, payload) {
            commit('SET_LABELGROUPS_GUIDES', payload)
        },
        setLabelGroupsVariant({ commit }, payload) {
            commit('SET_LABELGROUPS_VARIANT', payload)
        },
        unselectAllLabelGroupLabels({ state, commit }, payload) {
            const labelGroups = JSON.parse(JSON.stringify(state.labelGroups))

            if (labelGroups) {
                labelGroups.forEach(group => {
                    group.promos &&
                        group.promos.forEach(promo => {
                            promo.selectedToGenerateLabels = false
                        })
                })
            }

            commit('SET_LABELGROUPS', labelGroups)
            commit('SET_SELECTED_LABELGROUPS', [])
            return labelGroups
        },

        async selectLabelPromoGroup(
            { state, commit, dispatch, getters },
            payload
        ) {
            const { groupId, select } = payload

            const promoGroups = getters.getLabelGroupsJson
            const promoGroup = promoGroups.find(g => g.id === groupId)

            let selectedGroups = getters.getSelectedLabelGroupsJson
            const selectedGroup = selectedGroups.find(g => g.id === groupId)

            const areFiltersApplied = getters.arePromoFiltersApplied(
                'getLabelGroupsFilters'
            )

            if (promoGroup) {
                promoGroup.selectWholeGroup = select
            }

            let fetchedPromoIds = []
            if (!areFiltersApplied && !select) {
                fetchedPromoIds = []
            } else {
                const params = await dispatch(
                    'setLabelGroupsFilterQueryParams',
                    payload
                )
                const { promoIds } = await dispatch('fetchSelectedPromoIds', {
                    group: promoGroup,
                    params: params.paramsPromos,
                    commitName: 'SET_LABELGROUP_STATUS'
                })
                fetchedPromoIds = promoIds
            }

            // if group is already selected
            if (selectedGroup) {
                if (select) {
                    const newPromosArray = []

                    for (const promo of selectedGroup.promos) {
                        const p = await dispatch('selectLabelGroupLabel', {
                            promoId: promo.id,
                            value: true,
                            groupId: promo.promo_group_id,
                            groups: promoGroups,
                            returnPromo: true
                        })
                        newPromosArray.push(p)
                    }

                    selectedGroup.promos = newPromosArray

                    selectedGroup.selectedPromoIds = [
                        ...new Set([
                            ...fetchedPromoIds,
                            ...selectedGroup.selectedPromoIds
                        ])
                    ]
                    selectedGroup.selectWholeGroup = true
                } else {
                    if (!areFiltersApplied) {
                        selectedGroup.selectedPromoIds = []
                    } else {
                        selectedGroup.selectWholeGroup = false
                        fetchedPromoIds.forEach(promoId => {
                            const promo = selectedGroup.promos.find(
                                promo => promo.id === promoId
                            )
                            if (promo) {
                                promo.selectedToGenerateLabels = false
                                // do we need to reset pagination?
                                // commit('RESET_PROMOGROUP_PRODUCTS_PAGINATION', {
                                //     ...payload,
                                //     promoId: promo.id,
                                //     selected: true
                                // })
                            }
                            selectedGroup.selectedPromoIds = selectedGroup.selectedPromoIds.filter(
                                id => id !== promoId
                            )
                        })
                    }

                    if (!selectedGroup.selectedPromoIds.length) {
                        // remove group
                        selectedGroups = selectedGroups.filter(
                            g => g.id !== groupId
                        )
                    }
                }
                commit('SET_LABELGROUPS', promoGroups)
            } else {
                // if group is not selected
                if (select) {
                    // select whole group
                    for (const [idx, promo] of promoGroup.promos.entries()) {
                        const p = await dispatch('selectLabelGroupLabel', {
                            promoId: promo.id,
                            value: true,
                            groupId: promo.promo_group_id,
                            groups: promoGroups,
                            returnPromo: true
                        })
                        promoGroup.promos[idx] = p
                    }

                    if (!promoGroup.selectedPromoIds) {
                        promoGroup.selectedPromoIds = []
                    }
                    promoGroup.selectedPromoIds = [
                        ...new Set([
                            ...fetchedPromoIds,
                            ...promoGroup.selectedPromoIds
                        ])
                    ]

                    selectedGroups.push({
                        ...promoGroup,
                        selectWholeGroup: true
                    })
                }
            }

            commit('SET_SELECTED_LABELGROUPS', selectedGroups)
        },

        async selectLabelGroupLabel(
            { state, commit, dispatch, getters },
            payload
        ) {
            const groups = JSON.parse(JSON.stringify(payload.groups))
            const group = groups.find(g => g.id === payload.groupId)
            const promo = group.promos.find(p => p.id === payload.promoId)

            // search for promo in selected groups
            let sGroups = getters.getSelectedLabelGroupsJson
            const sGroup = sGroups.find(g => g.id === payload.groupId)
            const sPromo = sGroup?.promos.find(p => p.id === payload.promoId)

            // if select is false, remove promo from selected groups
            if (!payload.value) {
                sGroup.selectedPromoIds = sGroup.selectedPromoIds.filter(
                    id => id !== payload.promoId
                )

                // if group has no selected promos, remove group from selected groups
                if (!sGroup.selectedPromoIds.length) {
                    sGroups = sGroups.filter(e => e.id !== sGroup.id)
                }

                if (sPromo) {
                    sPromo.selectedToGenerateLabels = false
                    sPromo.showMore = false
                }

                commit('SET_SELECTED_LABELGROUPS', sGroups)
                return
            }

            // if promo is not in selected groups

            // if promo has no products fetched
            let products = promo.products || promo.product_sets
            if (!products?.length) {
                const resProducts = await dispatch('fetchProductsByPromoId', {
                    params: {
                        promo_id: payload.promoId,
                        main: true
                    },
                    promo
                })

                // set promo products
                let pagination
                if (getters.hasProductSets(promo.type)) {
                    promo.product_sets = resProducts
                    pagination = resProducts[0].pagination
                    products = resProducts.flatMap(
                        e => e.product_set_dict_products
                    )
                } else {
                    products = resProducts.data.data
                    pagination = resProducts.data.pagination[0]
                }

                promo.products = products
                promo.productsPagination = pagingMap(pagination)
                promo.productsStatus = 'idle'
            }

            // fetch subscriptions
            let subs = promo.subscriptions
            if (!promo?.subscriptions) {
                const resSubs = await dispatch('fetchSubscriptions', {
                    params: {
                        state: 'accepted',
                        promo_id: promo.id,
                        includes: 'merchant'
                    },
                    config: {
                        productSubscriptions: true,
                        productSetSubscriptions: true,
                        noCancel: true
                    }
                })

                const selectedMerchants =
                    getters.getLabelGroupsFilters[
                        'promo|subscription|merchant_id'
                    ].value

                subs = resSubs.data.data.map(sub => {
                    const checked = selectedMerchants.length
                        ? selectedMerchants.includes(sub.merchant_id)
                        : true

                    return {
                        ...sub,
                        checked,
                        merchant_network_id: sub.merchant.network_id,
                        products: products.map(p => {
                            return {
                                ...p,
                                // If product is main, it should have downloadLabel set to true by default
                                downloadLabel: !p.dict_product || (p.dict_product && p.dict_product.main !== false)
                            }
                        })
                    }
                })

                promo.subscriptions = subs

                promo.subscriptionsEqualPrices = {
                    equalPrices: false,
                    priceGroups: [subs]
                }
            }

            promo.selectedToGenerateLabels = payload.value
            promo.showMore = false

            if (payload.returnPromo) {
                return promo
            }

            if (sGroup) {
                const selectedPromoIds = [
                    ...new Set([...sGroup.selectedPromoIds, ...[promo.id]])
                ]
                sGroup.selectedPromoIds = selectedPromoIds

                if (sPromo) {
                    const index = sGroup.promos.findIndex(
                        p => p.id === payload.promoId
                    )
                    sGroup.promos[index] = JSON.parse(JSON.stringify(promo))
                } else {
                    sGroup.promos.push(promo)
                }
            } else {
                group.selectedPromoIds = [promo.id]

                sGroups.push(group)
            }

            commit('SET_SELECTED_LABELGROUPS', sGroups)
        },
        selectAllLabelProducts({ state, commit }, payload) {
            const labelGroups = JSON.parse(
                JSON.stringify(state.selectedLabelGroups)
            )
            const group = labelGroups.find(
                group => group.id === payload.groupId
            )
            const selectedPromo = group.promos.find(
                promo => promo.id === payload.promoId
            )
            selectedPromo.productDownloadLabelDefault = payload.selected
            selectedPromo.products.forEach(prod => {
                if (prod.main) prod.downloadLabel = payload.selected
            })
            if (selectedPromo.subscriptionsEqualPrices.equalPrices) {
                selectedPromo.subscriptionsEqualPrices.priceGroups.forEach(
                    priceGroup => {
                        priceGroup.forEach(subResource => {
                            subResource.selectAllProducts = payload.selected
                            subResource.products.forEach(product => {
                                product.downloadLabel = payload.selected
                            })
                        })
                    }
                )
            } else {
                selectedPromo.subscriptions.forEach(sub => {
                    sub.selectAllProducts = payload.selected
                    if (sub.merchant_id === payload.merchantId) {
                        sub.products.forEach(product => {
                            product.downloadLabel = payload.selected
                        })
                    }
                })
            }
            commit('SET_SELECTED_LABELGROUPS', labelGroups)
        },
        changeProductLabelDownloadState({ commit, getters }, payload) {
            const labelGroups = getters.getSelectedLabelGroupsJson

            const group = labelGroups.find(group => group.id === payload.groupId)
            if (!group) return

            const selectedPromo = group.promos.find(promo => promo.id === payload.promoId)
            if (!selectedPromo) return

            // Helper function to set downloadLabel for products
            const setProductDownloadLabel = (products) => {
                const { selected, product } = payload
                const productId = payload.product.id

                // If product has dict_product, it means it's a main product
                if (product.dict_product) {
                    const product = products.find(prod => prod.id === productId)
                    Vue.set(product, 'downloadLabel', selected)
                    return
                }

                const mainProduct = products.find(
                    p => p.id === product.promo_dict_product_id
                )

                if (mainProduct) {
                    if (!Array.isArray(mainProduct.subProducts)) {
                        Vue.set(mainProduct, 'subProducts', [])
                    }
                    // Check if the subProduct already exists in order to avoid duplicates
                    const alreadyExists = mainProduct.subProducts.some(sub => sub.id === product.id)
                    if (!alreadyExists) {
                        mainProduct.subProducts.push({
                            ...product,
                            print_copies: 1,
                            downloadLabel: selected
                        })
                    } else {
                        const existingSubProduct = mainProduct.subProducts.find(sub => sub.id === product.id)
                        Vue.set(existingSubProduct, 'downloadLabel', selected)
                    }
                }
            }

            // Setting downloadLabel for the main product
            setProductDownloadLabel(selectedPromo.products, payload.productId, payload.selected)

            // Setting downloadLabel for products in subscriptions
            if (selectedPromo.subscriptionsEqualPrices.equalPrices) {
                selectedPromo.subscriptionsEqualPrices.priceGroups.forEach(priceGroup => {
                    priceGroup.forEach(subResource => {
                        setProductDownloadLabel(subResource.products, payload.productId, payload.selected)
                    })
                })
            } else {
                selectedPromo.subscriptions.forEach(sub => {
                    if (sub.merchant_id === payload.merchantId) {
                        setProductDownloadLabel(sub.products, payload.productId, payload.selected)
                    }
                })
            }

            commit('SET_SELECTED_LABELGROUPS', labelGroups)
        },
        async downloadLabelGroups(
            { state, commit, getters, dispatch },
            { methodSend, queueId }
        ) {
            const priceTagsAttributes = getters.getPriceTagsAttributes

            commit('SET_DOWNLOAD_LABELGROUPS_STATUS', 'loading')

            const priceTagResponse = await this.$api.post(
                'pricing/download',
                Object.assign(state.priceTagConfig, {
                    labels_attributes: priceTagsAttributes
                }),
                { config: { noCancel: true } }
            )

            const checkQueue = async uuid => {
                const queueStatus = await this.$api.get(
                    `pricing/download/${uuid}/status`
                )
                const state = queueStatus.data?.data?.state
                if (state !== 'pending') {
                    dispatch('abortLabelsDownload', queueId)
                    if (state === 'finished') {
                        Vue.prototype.$functions.downloadFile(
                            queueStatus.data.data.file_url,
                            queueStatus.data.data.file_name
                        )
                    } else if (state === 'error') {
                        dispatch('addNotification', {
                            type: 'danger',
                            content: 'Wystąpił błąd. Spróbuj ponownie później.'
                        })
                    }
                    commit('SET_DOWNLOAD_LABELGROUPS_STATUS', state === 'no_found' ? 'no_found' : 'idle')
                }
            }

            const queueUuid = priceTagResponse.data.data.uuid
            checkQueue(queueUuid)
            const interval = setInterval(() => {
                checkQueue(queueUuid)
            }, 2500)

            commit('ADD_TO_DOWNLOAD_QUEUE', {
                queueId,
                interval
            })
        },
        async abortLabelsDownload({ state, commit }, payload) {
            const queue = state.downloadLabelGroupsQueues.find(
                e => e.queueId === payload
            )
            clearInterval(queue.interval)
            commit('SET_DOWNLOAD_LABELGROUPS_STATUS', 'idle')
        },

        async loadLabelProducts({ state, commit, dispatch, getters }, payload) {
            const { promo_group_id: groupId, id } = payload.promo
            const { params } = payload
            const commitName = payload.commitName || 'SET_LABELGROUPS'

            const groups = payload.groups || getters.getLabelGroupsJson
            const group = groups.find(group => group.id === groupId)
            const promo = group.promos.find(promo => promo.id === id)

            Vue.set(promo, 'productsStatus', 'loading')
            commit(commitName, groups)

            const resProducts = await dispatch('fetchProductsByPromoId', {
                params: {
                    ...params,
                    promo_id: id,
                    main: params.main === undefined ? true : params.main
                },
                promo,
                productSetId: payload.productSetId
            })

            // if per page changed, slice res products
            if (
                params.main !== false &&
                promo.productsPagination &&
                params.per &&
                promo.productsPagination.perPage !== params.per
            ) {
                const slice = promo.productsPagination.perPage
                if (getters.hasProductSets(promo.type)) {
                    resProducts.forEach(el => {
                        el.product_set_dict_products = el.product_set_dict_products.slice(
                            slice
                        )
                    })
                } else {
                    resProducts.data.data = resProducts.data.data.slice(slice)
                }
            }

            // set promo products
            let products
            let pagination
            if (getters.hasProductSets(promo.type)) {
                if (!promo.product_sets) {
                    promo.product_sets = []
                    promo.product_sets.push(...resProducts)
                }
                if (params.main) {
                    pagination = pagingMap(resProducts[0].pagination)
                }
                products = resProducts.flatMap(e => e.product_set_dict_products)
            } else {
                pagination = pagingMap(resProducts.data.pagination[0])
                products = resProducts.data.data
            }

            if (!promo.products) {
                promo.products = []
            }
            promo.products.push(...products)

            if (payload.fetchPaginationOnly) {
                promo.totalProductsRecords = pagination.totalRecords
            }

            Vue.set(promo, 'productsStatus', 'idle')
            if (params.main) {
                Vue.set(promo, 'productsPagination', pagination)
            }

            if (payload.groups) {
                return {
                    groups,
                    promo
                }
            }
            commit(commitName, groups)
        },

        async fetchProductsByPromoLabel(
            { commit, dispatch, getters },
            payload
        ) {
            const groups = getters.getSelectedLabelGroupsJson
            const promoGroup = groups.find(
                group => group.id === payload.groupId
            )

            if (!promoGroup) return

            let searchedPromo = promoGroup.promos.find(
                promo => promo.id === payload.promoId
            )

            // fetch products
            let productsBefore
            if (searchedPromo.products) {
                productsBefore = JSON.parse(
                    JSON.stringify(searchedPromo.products)
                )
            }

            const resProd = await dispatch('loadLabelProducts', {
                params: {
                    ...payload.params,
                    page: payload.page || 1,
                    per: payload.per || 10,
                    main: payload.main === undefined ? true : payload.main,
                    promo_id: payload.promoId
                },
                promo: searchedPromo,
                groups,
                id: payload.promoId,
                commitName: 'SET_SELECTED_LABELGROUPS',
                productSetId: payload.productSetId
            })

            searchedPromo = resProd.promo
            const productsAfter = resProd.promo.products

            if (!searchedPromo) return

            searchedPromo.groupId = payload.groupId
            searchedPromo.selectedToGenerateLabels = true
            if (searchedPromo.productDownloadLabelDefault === undefined) {
                searchedPromo.productDownloadLabelDefault = true
            }

            // if promo has no subscriptions, fetch them
            if (!searchedPromo.subscriptions) {
                const [promoWithSubsData] = await dispatch(
                    'fetchSubscriptionsByPromoId',
                    {
                        state: 'accepted',
                        noCancel: true,
                        promos: [searchedPromo],
                        'merchant|nip': payload['merchant|nip']
                    }
                )
                if (promoWithSubsData.subscriptions) {
                    promoWithSubsData.subscriptions.forEach(sub => {
                        sub.checked = true
                    })
                }

                searchedPromo.subscriptions = promoWithSubsData.subscriptions
                searchedPromo.subscriptionsEqualPrices =
                    promoWithSubsData.subscriptionsEqualPrices
            }

            // take only new products
            let newProducts
            if (!productsBefore) {
                newProducts = productsAfter
            } else {
                newProducts = productsAfter.filter(
                    el => !productsBefore.some(e => e.id === el.id)
                )
            }

            const setProduct = (sub, product) => {
                if (!sub.products) {
                    sub.products = []
                }

                const sProduct = sub.products.find(p => p.id === product.id)

                if (!sProduct) {
                    sub.products.push(product)
                }
            }

            // set subscription products
            newProducts.forEach(product => {
                product.downloadLabel =
                    searchedPromo.productDownloadLabelDefault

                if (searchedPromo.subscriptions) {
                    searchedPromo.subscriptions.forEach(sub => {
                        setProduct(sub, product)
                    })
                }

                searchedPromo.subscriptionsEqualPrices.priceGroups.forEach(
                    priceGroup => {
                        priceGroup.forEach(sub => {
                            setProduct(sub, product)
                        })
                    }
                )
            })

            commit('SET_SELECTED_LABELGROUPS', groups)
        },

        async loadSelectedLabelPromos({ commit, dispatch, getters }, payload) {
            const { group } = payload

            try {
                commit('SET_SELECTED_LABELGROUP_STATUS', {
                    groupId: group.id,
                    status: 'loading'
                })
                const { groups, pagination } = await dispatch(
                    'fetchAndConcatPromos',
                    {
                        ...payload,
                        subState: 'accepted',
                        groups: getters.getSelectedLabelGroups,
                        selected: true,
                        selectedToGenerateLabels: true,
                        equalPrices: false
                    }
                )

                const newGroup = groups.find(e => e.id === group.id)
                newGroup.promos.forEach(promo => {
                    promo.labels = {}
                    promo.productDownloadLabelDefault = true
                })

                commit('SET_SELECTED_LABELGROUP_PROMOS', {
                    groupId: newGroup.id,
                    promos: newGroup.promos
                })
                if (payload.mainCollection === false) return groups

                commit('SET_SELECTED_LABELGROUP_PAGINATION', {
                    groupId: group.id,
                    pagination
                })
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_SELECTED_LABELGROUP_STATUS', {
                    groupId: group.id,
                    status: 'idle'
                })
            }
        },

        async fetchLabelsPromosByPromoGroup({ dispatch }, payload) {
            const { group, per, page } = payload
            const { paramsPromos } = await dispatch(
                'setLabelGroupsFilterQueryParams'
            )

            dispatch('loadUnselectedLabels', {
                params: {
                    ...paramsPromos,
                    per,
                    page
                },
                group,
                append: page > 1
            })
        },

        async loadLabelsProductsAndResources({ dispatch }, payload) {
            await dispatch('fetchProductsByPromoLabel', {
                ...payload
            })

            await dispatch('loadLabelsResources', {
                promo: payload.promo
            })
        },

        async loadLabelsResources({ commit, dispatch, getters }, payload) {
            const { promo } = payload

            const groups = getters.getSelectedLabelGroupsJson
            const group = groups.find(g => g.id === promo.promo_group_id)
            const sPromo = group?.promos.find(p => p.id === promo.id)

            const dictIds = sPromo?.products
                .filter(p => !p.hasResources)
                .map(e => e.dict_product_id)
                .join(',')

            if (!dictIds) return

            const setProductProperties = (subs, resource) => {
                const sub = subs.find(s => s.id === resource.subscription_id)
                if (!sub) return

                const product = sub.product_subscriptions.find(
                    p => p.id === resource.promo_dict_product_subscription_id
                )

                if (!product) return

                if (resource.main) {
                    Vue.set(product, 'subscription_resource_id', resource.id)
                }
                Vue.set(product, 'print_copies', 1)
                Vue.set(product, 'productPrice', resource.price_normal)
                Vue.set(product, 'price_default', null)
                Vue.set(product, 'price_lowest', resource.price_lowest)
            }

            try {
                const { data } = await dispatch('fetchSubscriptionResources', {
                    'subscription|promo_id': promo.id,
                    'subscription|suspended': false,
                    subscription_id: promo.subscriptions
                        .map(el => el.id)
                        .join(','),
                    dict_product_id: dictIds || undefined
                })

                if (!data.data) return

                for (const resource of data.data) {
                    const product = sPromo.products.find(
                        p => p.id === resource.promo_dict_product_id
                    )
                    Vue.set(product, 'hasResources', !!product)

                    setProductProperties(sPromo.subscriptions, resource)

                    sPromo.subscriptionsEqualPrices.priceGroups.forEach(
                        subs => {
                            setProductProperties(subs, resource)
                        }
                    )
                }

                commit('SET_SELECTED_LABELGROUPS', groups)
            } catch (err) {
                console.log(err)
            }
        },

        async loadUnselectedLabels({ commit, dispatch, getters }, payload) {
            const { params, group, append } = payload

            // set promos status
            group.promosStatus = 'loading'
            commit('SET_LABELGROUP', group)

            // fetch promos
            const resPromos = await dispatch('fetchPromosByGroupId', {
                ...params,
                includes: 'company,company.logo,logo',
                promo_group_id: group.id
            })

            if (!resPromos.data?.data) {
                // set promos status
                group.promosStatus = 'idle'
                commit('SET_LABELGROUP', group)
                return
            }

            // map fetched promos
            const promos = resPromos.data.data.map(promo => {
                promo.groupId = group.id
                promo.selectedToGenerateLabels = false
                promo.productDownloadLabelDefault = true
                promo.usage_limit_per_receipt = +promo.usage_limit_per_receipt
                return promo
            })

            // set total promos count
            const promosPaging = pagingMap(resPromos.data.pagination[0])
            group.countPromos = promosPaging.totalRecords

            // count product for each promo
            const promises = []
            for (const promo of promos) {
                const loadProducts = async () => {
                    // if (getters.hasProductSets(promo.type)) {
                    //     res = await dispatch('fetchProductSets', {
                    //         params: {
                    //             ...params,
                    //             includes: 'product_set_dict_products'
                    //         },
                    //         config
                    //     })

                    //     const totalProducts = res.data.data.reduce((acc, e) => {
                    //         return (
                    //             acc +
                    //             e.product_set_dict_products.filter(
                    //                 el => el.main
                    //             ).length
                    //         )
                    //     }, 0)
                    //     promo.totalProductsRecords = totalProducts
                    // } else {
                    //     res = await dispatch('fetchProducts', {
                    //         params,
                    //         config
                    //     })

                    //     if (res.data.pagination) {
                    //         promo.totalProductsRecords = +res.data.pagination[0]
                    //             .totalRecords
                    //     }
                    // }
                    const { status, data } = await dispatch('fetchProducts', {
                        params: {
                            promo_id: promo.id,
                            main: true,
                            per: 1,
                            page: 1
                        },
                        config: {
                            noCancel: true
                        }
                    })

                    if (status !== 200 || !data?.pagination) {
                        throw new Error('Failed to fetch products for promo')
                    }
                    promo.totalProductsRecords = +data.pagination[0].totalRecords
                }
                promises.push(loadProducts())
            }
            await Promise.all(promises)

            group.pagination = promosPaging
            group.promosStatus = 'idle'

            if (append) {
                group.promos.push(...promos)
            } else {
                group.promos = promos
            }
            commit('SET_LABELGROUP', group)
        },

        async setLabelGroupsFilterQueryParams(
            { state, commit, dispatch, getters },
            payload
        ) {
            const paramsAdditional = await dispatch(
                'setPromotionsTimeParams',
                state.filters
            )
            let paramsGroups = await dispatch('setFilterQueryParams', {
                filters: state.filters
            })
            paramsGroups['promo|company_merchant|status'] = 'active'
            paramsGroups['promo|state'] = 'active'
            paramsGroups['promo|subscription|state'] = 'accepted'
            paramsGroups['promo|subscription|suspended'] = false
            paramsGroups['promo|type'] = state.filters['promo|type'].value
                .length
                ? state.filters['promo|type'].value.join(',')
                : getters.getLabelPromoTypes.join(',')

            if (payload && payload.fetchSpecificIds) {
                paramsGroups.id = payload.fetchSpecificIds
            }
            if (payload && payload.fetchSpecificPromoId) {
                paramsGroups['promo|id'] = payload.fetchSpecificPromoId
            }
            // loyalty
            if (paramsGroups['promo|type']?.includes('loyalty')) {
                const changedPromoTypes = paramsGroups['promo|type'].replace(
                    'loyalty',
                    ''
                )

                paramsGroups['promo|type'] = changedPromoTypes.length
                    ? changedPromoTypes
                    : getters.getLabelPromoTypes.join(',')
                paramsGroups['promo|loyalty'] = true
            }
            paramsGroups = { ...paramsGroups, ...paramsAdditional }

            // if no merchants selected, add all available merchants
            if (
                !state.filters['promo|subscription|merchant_id']?.value.length
            ) {
                paramsGroups[
                    'promo|subscription|merchant_id'
                ] = getters.getAvailableMerchants.map(el => el.id).join()
            }

            // change query params for promo requests
            const paramsPromos = {}
            for (const [key, value] of Object.entries(paramsGroups)) {
                if (key === 'name') continue
                const newKey = key.replace('promo|', '')
                paramsPromos[newKey] = value
            }

            paramsGroups.sort = state.sort.by
            paramsGroups.direction = state.sort.direction
            return {
                paramsPromos,
                paramsGroups
            }
        },

        async loadLabelGroups({ state, commit, getters, dispatch }, payload) {
            try {
                if (getters.isLotteryUser) {
                    commit('SET_LABELS', lotteryLabels)
                    commit('SET_LABELS_PAGINATION', {
                        page: 1,
                        totalPages: 0,
                        perPage: 5,
                        totalRecords: null
                    })
                    return
                }
                if (getters.getWalkthroughActive) {
                    commit('SET_LABELGROUPS', [wtLabelGroups[0]])
                    commit('SET_LABELS_PAGINATION', {
                        page: 1,
                        totalPages: 1,
                        perPage: 5,
                        totalRecords: 1
                    })
                    return
                }

                commit('SET_LABELGROUPS', null)

                // set query params
                const params = await dispatch(
                    'setLabelGroupsFilterQueryParams',
                    payload
                )
                const paramsGroups = {
                    per: 5,
                    ...params.paramsGroups,
                    ...payload.params
                }

                // fetch groups
                const resGroups = await dispatch('fetchPromoGroups', {
                    paramsGroups,
                    noCancel: !(payload && payload.fromFilters)
                })

                if (this.$api.isCancel(resGroups)) {
                    return
                }

                let groups = resGroups.data.data

                // handle pagination
                const paging = pagingMap(resGroups.data.pagination[0])

                dispatch('saveLocalForagePagination', {
                    labels: paging.perPage
                })

                // append groups
                if (payload?.appendGroups) {
                    const tmpLabelGroups = getters.getLabelGroupsJson
                    if (tmpLabelGroups[0]) {
                        groups = [...groups, ...tmpLabelGroups]
                    }
                }

                for (const group of groups) {
                    group.promosStatus = 'loading'
                    group.pagination = paging
                }
                commit('SET_LABELGROUPS', groups)

                const areFiltersApplied = getters.arePromoFiltersApplied(
                    'getLabelGroupsFilters'
                )

                // fetch promos for each group
                const paramsPromos = {
                    per: 2,
                    includes: 'company,company.logo,logo',
                    ...params.paramsPromos
                }

                groups.forEach(group => {
                    group.showPromosOnLabelsGenerateView = false

                    dispatch('loadUnselectedLabels', {
                        params: paramsPromos,
                        group
                    })
                })

                if (areFiltersApplied) {
                    for (const group of groups) {
                        if (group.countPromos !== undefined) continue

                        // count promos in group
                        const resCount = await dispatch(
                            'fetchPromosByGroupId',
                            {
                                promo_group_id: group.id,
                                per: 1,
                                page: 1,
                                state: paramsPromos?.state,
                                'company_merchant|status':
                                    paramsPromos?.['company_merchant|status'],
                                'subscription|state':
                                    paramsPromos?.['subscription|state'],
                                'subscription|merchant_id':
                                    paramsPromos?.['subscription|merchant_id']
                            }
                        )
                        group.countPromos =
                            resCount.data?.pagination?.[0]?.totalRecords
                    }
                }

                commit('SET_LABELGROUPS', groups)
                commit('SET_LABELGROUPS_PAGINATION', paging)

                return groups
            } catch (err) {
                console.log(err)
            }
        },

        async loadSelectedLabelGroups(
            { state, commit, getters, dispatch },
            payload
        ) {
            try {
                if (getters.getWalkthroughActive) {
                    commit('SET_SELECTED_LABELGROUPS', wtLabelGroups)
                    return
                }
                let { groups } = payload

                commit('SET_SELECTED_LABELGROUPS', null)
                const params = await dispatch(
                    'setLabelGroupsFilterQueryParams',
                    payload
                )
                // fetch groups
                const resGroups = await dispatch('fetchPromoGroups', {
                    paramsGroups: {
                        id: groups.map(e => e.id).join(','),
                        ...params.paramsGroups
                    }
                })

                groups = resGroups.data.data.map(rGroup => {
                    const group = groups.find(e => e.id === rGroup.id)
                    return {
                        ...group,
                        ...rGroup
                    }
                })

                for (const group of groups) {
                    group.promosStatus = 'loading'
                }
                commit('SET_SELECTED_LABELGROUPS', groups)

                // fetch promos for each group
                const paramsPromos = {
                    per: 2,
                    includes: 'company,company.logo,logo',
                    ...params.paramsPromos,
                    ...payload.paramsPromos
                }

                const promises = []
                groups.forEach(async group => {
                    group.selectedPromoIds = [...new Set(group.selectedPromoIds)]
                    const fetchPromos = async () => {
                        group.showPromosOnLabelsGenerateView = false

                        const { data } = await this.$api.get('promos', {
                            params: {
                                ...paramsPromos,
                                id: group.selectedPromoIds.join(',')
                            }
                        })

                        const promos = data.data.map(promo => {
                            return {
                                ...promo,
                                selectedToGenerateLabels: true
                            }
                        })
                        const promosPaging = pagingMap(data.pagination[0])
                        group.countPromos = promosPaging.totalRecords
                        group.pagination = promosPaging
                        group.promos = promos
                    }
                    promises.push(fetchPromos())
                })

                await Promise.all(promises)

                commit('SET_SELECTED_LABELGROUPS', groups)
            } catch (err) {
                console.log(err)
            }
        },

        setLabelGroupsSort({ commit }, payload) {
            commit('SET_LABELS_SORT', payload)
        },
        openProductsWithErrors({ commit, getters }, payload) {
            const selectedGroups = getters.getSelectedLabelGroups
            payload.forEach(error => {
                const group = selectedGroups.find(g => g.id === error.groupId)
                const promo = group.promos.find(p => p.id === error.promoId)
                const product = promo.products.find(
                    p => p.id === error.productId
                )
                if (promo.subscriptionsEqualPrices.equalPrices) {
                    promo.subscriptionsEqualPrices.priceGroups.forEach(
                        priceGroup => {
                            priceGroup.forEach(sub => {
                                const productIns = sub.products.find(
                                    p => p.id === error.productId
                                )
                                productIns.showExtraFields = true
                            })
                        }
                    )
                } else {
                    promo.subscriptions.forEach(sub => {
                        if (sub.merchant_id === error.merchantId) {
                            const productIns = sub.products.find(
                                p => p.id === error.productId
                            )
                            productIns.showExtraFields = true
                        }
                    })
                }
                product.showExtraFields = true
            })
            commit('SET_WEIGHT_PRODUCTS_ERRORS', payload)
        },
        setUnloadedPromosWithMandatoryPrice({ commit }, payload) {
            commit('SET_UNLOADED_PROMOS_MANDATORY_PRICE', payload)
        },
        setMandatoryPriceGroups({ commit }, payload) {
            commit('SET_MANDATORY_PRICE_PROMO_GROUPS', payload)
        },
        setCancelMandatoryPricePromoGroupsLoad({ commit }, payload) {
            commit('SET_CANCEL_MANDATORY_PRICE_PROMO_GROUPS_LOAD', payload)
        },
        async fetchMandatoryPricePromoGroups(
            { commit, getters, state },
            payload
        ) {
            try {
                commit('SET_MANDATORY_PRICE_PROMO_GROUPS_STATUS', 'loading')
                commit('SET_MANDATORY_PRICE_ERROR', false)
                const res = await this.$api.post(
                    'checkPricesForPriceTags',
                    payload
                )
                if (!res) {
                    commit('SET_MANDATORY_PRICE_ERROR', true)
                }
                const resData = res?.data?.data
                if (resData && !state.isCancelMandatoryPricePromoGroupsLoad) {
                    commit('SET_MANDATORY_PRICE_PROMO_GROUPS', resData)
                }
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_MANDATORY_PRICE_PROMO_GROUPS_STATUS', 'idle')
            }
        },
        resetPromoGroupsWithMandatoryPriceStatus({ commit }) {
            commit('SET_MANDATORY_PRICE_PROMO_GROUPS', [])
            commit('SET_MANDATORY_PRICE_PROMO_GROUPS_STATUS', 'idle')
            commit('SET_CANCEL_MANDATORY_PRICE_PROMO_GROUPS_LOAD', false)
            commit('SET_MANDATORY_PRICE_VALIDATION', false)
        },
        async toggleMandatoryPricePromos(
            { commit, dispatch, getters },
            payload
        ) {
            try {
                const promos = await dispatch('loadSelectedLabelPromos', {
                    group: payload.group,
                    per: 10,
                    page: payload.page,
                    params: {
                        id: payload.params.id.join(',')
                    }
                })
                const promoGroups = promos || getters.getSelectedLabelGroups
                const selectedGroups = await JSON.parse(
                    JSON.stringify(promoGroups)
                )
                const selectedGroup = selectedGroups.find(
                    group => group.id === payload.group.id
                )
                selectedGroup.promosWithEmptyMandatoryPrice = true
                selectedGroup.promos.map(promo => {
                    if (payload.params.id.includes(promo.id)) {
                        promo.emptyMandatoryPrice = true
                    }
                })
                commit('SET_SELECTED_LABELGROUPS', selectedGroups)
            } catch (err) {
                console.log(err)
            }
        },
        resetDownloadLabelGroupsStatus ({ commit }) {
            commit('SET_DOWNLOAD_LABELGROUPS_STATUS', 'idle')
        }
    },
    getters: {
        getWeightProductError: state => args => {
            if (state.weightProductsErrors?.length) {
                return !!state.weightProductsErrors.find(
                    error =>
                        error.groupId === args.groupId &&
                        error.promoId === args.promoId &&
                        error.productId === args.productId &&
                        error.field === args.field
                )
            } else {
                return false
            }
        },
        getPriceTagsAttributes: (state, getters) => {
            function prepareProductAttribute(p) {
                const { print_copies = 1, payload, productPrice, price_lowest } = p

                const product = {
                    print_copies: Math.max(1, Math.round(print_copies))
                }

                for (const key in (payload || {})) {
                    if (payload[key] !== undefined && payload[key] !== null) {
                        product[key] = payload[key]
                    }
                }

                if (productPrice !== undefined) {
                    product.price_normal = productPrice
                }

                if (price_lowest) {
                    product.price_lowest = price_lowest
                }

                if (p.dict_product.ean) {
                    product.ean = p.dict_product.ean
                }

                return product
            }

            function checkIfProductIsModified(product) {
                if (product.print_copies > 1) {
                    return true
                }
                if (+product.price_lowest === 0) {
                    delete product.price_lowest
                    return true
                }

                for (const key in product) {
                    if (
                        key !== 'print_copies' &&
                        key !== 'promo_dict_product_subscription_id' &&
                        key !== 'ean'
                    ) {
                        if (
                            product[key] !== undefined &&
                            product[key] !== null
                        ) {
                            return true
                        }
                    }
                }

                return false
            }

            function handleSubscription(promo, sub, promoAttr) {
                if (!sub.checked) {
                    // If shop is not selected, skip it
                    return
                }

                const products = sub.products || []

                for (const product of products) {
                    const prodSubscription = sub.product_subscriptions.find(
                        ps => ps.promo_dict_product_id === product.id
                    )

                    // Build product attribute
                    const productAttr = prepareProductAttribute(product) || {}
                    productAttr.promo_dict_product_subscription_id = prodSubscription.id

                    for (const subProduct of product.subProducts || []) {
                        if (subProduct.downloadLabel !== true) continue

                        // If subProduct has downloadLabel set to true, add product-level attribute
                        labelsAttributes.push({
                            ean: subProduct.ean,
                            print_copies: subProduct.print_copies || 1,
                            promo_dict_product_subscription_id: prodSubscription.id
                        })
                    }

                    if (!product.downloadLabel) {
                        // If product is not selected for label, exclude it from the promo-level attribute
                        promoAttr.excluded_promo_dict_product_subscription_ids.push(
                            productAttr.promo_dict_product_subscription_id
                        )
                        continue
                    }

                    if (sub.selectAllProducts === false) {
                        /**
                         * If user clicked deselect all products, no need to check if product is modified,
                         * just add product-level attribute no matter if it is modified or not.
                         */
                        labelsAttributes.push(productAttr)
                        continue
                    }

                    const isProductModified = checkIfProductIsModified(productAttr)
                    if (isProductModified) {
                        // If product is modified, add product-level attribute...
                        labelsAttributes.push(productAttr)

                        // ...and exclude it from the promo-level attribute
                        promoAttr.excluded_promo_dict_product_subscription_ids.push(
                            productAttr.promo_dict_product_subscription_id
                        )
                    }
                }

                /**
                 * When all products are loaded and none of them has downloadLabel set to true,
                 * we don't need to add the promo-level attribute for this group.
                 */
                if (sub.selectAllProducts === false) {
                    return
                }
                const productsPagination = promo.productsPagination
                const allMainProductsLoaded = !(productsPagination || {}).nextPage
                if (productsPagination && allMainProductsLoaded && products.every(p => p.downloadLabel === false)) {
                    return
                }

                promoAttr.merchant_ids.push(sub.merchant_id)
                // labelsAttributes.push(promoAttr)
            }

            const labelsAttributes = []

            for (const group of state.selectedLabelGroups) {
                for (const promo of group.promos) {
                    if (!promo.selectedToGenerateLabels) continue

                    // Initialize promo-level attribute
                    const promoAttr = {
                        promo_id: promo.id,
                        merchant_ids: [],
                        excluded_promo_dict_product_subscription_ids: []
                    }

                    if (promo.subscriptionsEqualPrices?.equalPrices) {
                        for (const group of (promo.subscriptionsEqualPrices.priceGroups || [])) {
                            for (const sub of group) {
                                const merchant = getters.getMerchantById(sub.merchant_id)
                                if (merchant.state !== 'active') continue
                                handleSubscription(promo, sub, promoAttr)
                            }
                            labelsAttributes.push(promoAttr)
                        }
                    } else if (promo.subscriptions) {
                        for (const sub of promo.subscriptions) {
                            const merchant = getters.getMerchantById(sub.merchant_id)
                            if (merchant.state !== 'active') continue
                            handleSubscription(promo, sub, promoAttr)
                        }
                        labelsAttributes.push(promoAttr)
                    } else {
                        labelsAttributes.push(promoAttr)
                    }
                }

                // Add unloaded promos
                group.selectedPromoIds.forEach(pId => {
                    const sPromo = group.promos.find(p => p.id === pId)

                    if (!sPromo || (sPromo && sPromo.promoDetailsNotFetched)) {
                        const attribute = {
                            promo_id: pId
                        }

                        const filterMerchants =
                            state.filters['promo|subscription|merchant|nip']
                                .value
                        if (filterMerchants.length) {
                            attribute.merchant_ids = filterMerchants
                        }

                        labelsAttributes.push(attribute)
                    }
                })
            }

            return labelsAttributes
        },
        getLabelGroupsMerchantHeader: state =>
            state.priceTagConfig.merchant_header,
        getLabelGroupsGuides: state => state.priceTagConfig.guides,
        getLabelGroupsVariant: state => state.priceTagConfig.variant,
        getLabelGroupsDownloadStatus: state => state.downloadStatus,
        getLabelGroups: state => state.labelGroups,
        getLabelGroupsJson: state =>
            JSON.parse(JSON.stringify(state.labelGroups)),
        getSelectedLabelGroupBoolean: (state, getters) => (
            promoId,
            groupId
        ) => {
            if (state.selectedLabelGroups) {
                const group = getters.getSelectedLabelGroup(groupId)
                if (group?.selectedPromoIds) {
                    return group.selectedPromoIds.includes(promoId)
                }
                return false
            }
        },
        getLabelGroupsPagination: state => {
            return state.pagination
        },

        getLabelGroupsStatus: state => state.status,
        getSelectedLabelGroup: state => id =>
            state.selectedLabelGroups.find(group => group.id === id),
        getSelectedLabelGroups: state => state.selectedLabelGroups,
        getSelectedLabelGroupsJson: state =>
            JSON.parse(JSON.stringify(state.selectedLabelGroups)),
        getPromotionLabelShopsEP: (state, getters) => payload => {
            const promo = getSelectedPromoGroupPromo(state, payload)
            const subscriptions = promo.subscriptionsEqualPrices.priceGroups
            return subscriptions
        },
        getPromotionLabelShops: (state, getters) => payload => {
            const promo = getSelectedPromoGroupPromo(state, payload)
            return promo?.subscriptions.filter(el => el.state === 'accepted')
        },
        getSelectedLabelPromo: (state, getters) => ({ promoId, groupId }) => {
            const group = getters.getSelectedLabelGroupsJson.find(({ id }) => id === groupId)
            return ((group || {}).promos || []).find(({ id }) => id === promoId)
        },
        getLabelGroupsShopContactById: state => shopId => {
            return state.labelGroupsShopsContacts.find(
                el => el.shop_id === shopId
            )
        },
        getLabelsSelectedShopContacts: state => {
            return state.labelGroupsShopsContacts.filter(el => el.selected)
        },
        getLabelGroupsFilters: state => {
            return state.filters
        },
        getLabelGroupsSortOptions: state => {
            return state.sortOptions
        },
        getLabelGroupsSort: state => {
            return state.sort
        },
        getLabelMaxPrice: state => state.labelMaxPrice,
        getWalkthroughModalLabelsStep: state =>
            state.walkthroughModalLabelsStep,
        geLabelPromoTypesForPromoFilters: state => {
            return [
                { label: 'Tylko z aplikacją', value: 'loyalty' },
                ...state.promoTypesForPromoFilters
            ]
        },
        getUnloadedPromosMandatoryPrice: state => {
            return state.unloadedPromosMandatoryPrice
        },
        getLabelGroupsMerchantsForSelect: (state, getters) => {
            return getters.getMerchantsForSelect.map(el => {
                const selectedNips =
                    state.filters['promo|subscription|merchant|nip'].value
                const isDisabled = !!(
                    selectedNips.length &&
                    !selectedNips.includes(el.nip.toString())
                )
                const tooltip = isDisabled
                    ? 'Filtr niedostępny: sklep nie należy do wybranego NIPu'
                    : undefined

                return {
                    label: el.label,
                    value: el.value,
                    disabled: isDisabled,
                    tooltip
                }
            })
        },
        getMandatoryPricePromoGroupsStatus: state => {
            return state.mandatoryPricePromoGroupsStatus
        },
        getMandatoryPricePromoGroups: state => {
            return state.mandatoryPricePromoGroups
        },
        getMandatoryPriceValidation: state => {
            return state.mandatoryPriceValidation
        },
        getCancelMandatoryPricePromoGroupsLoad: state => {
            return state.isCancelMandatoryPricePromoGroupsLoad
        },
        getMandatoryPricePromoGroupsError: state => {
            return state.mandatoryPriceError
        }
    }
}
